import React, { useState, useEffect, useCallback } from "react";
import Modal1 from './ProjectModals/modal1.jsx'
import Modal2 from './ProjectModals/modal2.jsx'
import Modal3 from './ProjectModals/modal3.jsx'
import axios from "axios";
import { Modal } from "reactstrap";

const ProjectCard = () => {




  return (

    /* These are Project Cards */
    <React.Fragment>
        <div className="col-md-6 col-md-6 col-xl-4">
          <div className="card shadow-lg m-1 bg-white rounded">
            <div className="view overlay">
              









              <img className="card-img-top mask rgba-black-slight" src={require("./ProjectModals/modalimgs/mountaincarmodal.jpg")} alt="Card image cap"></img>
              <a>
                <div className="mask rgba-white-slight"></div>
              </a>
            </div>
            <div className="card-body">
              <div className="w-100 text-center">
                <h4 className="card-title">Mountain Car DQN</h4>
              </div>
              <hr />
              <p className="card-text">DQN deep learning model written in Python. This project utilizes the Tensorflow 2 framework with Tensorflow-Keras as the back-end API to construct the neural network.</p>
              <p></p>
              <div className="text-center mx-auto">
                <a
                  href="#"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                  data-toggle="modal" data-target="#Modal1"
                >
                  <i className="fas fa-clipboard-check" /> Demo
                </a>
                <a
                  href="https://github.com/scottvcaputo/MountainCarDQN"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                >
                  <i className="fab fa-github" /> Source
                </a>
              </div>
            </div>
          </div>
        </div>










        <div className="col-md-6 col-md-6 col-xl-4">
          <div className="card shadow-lg m-1 bg-white rounded">
            <div className="view overlay">
              
              <img className="card-img-top" src={require("./ProjectModals/modalimgs/styletransfermodal.jpg")}></img>
              <a>
                <div className="mask rgba-white-slight"></div>
              </a>
            </div>
            <div className="card-body">
              <div className="w-100 text-center">
                <h4 className="card-title">Neural Style Transfer</h4>
              </div>
              <hr />
              <p className="card-text"> Implemented neural style transfer in order to create images derived from a content image and a style reference image allowing the user to create their own artwork.</p>
              <div className="text-center mx-auto">
                <a
                  href="#"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                  data-toggle="modal" data-target="#Modal2"
                >
                  <i className="fas fa-clipboard-check" /> Demo
                </a>
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                >
                  <i className="fab fa-github" /> Source
                </a>
              </div>
            </div>
          </div>
        </div>















        <div className="col-md-6 col-md-6 col-xl-4">
          <div className="card shadow-lg m-1 bg-white rounded">
            <div className="view overlay">
              <img className="card-img-top mask rgba-black-slight" src={require("./ProjectModals/modalimgs/algomodal.png")}></img>
              <a>
                <div className="mask rgba-white-slight"></div>
              </a>
            </div>
            <div className="card-body">
              <div className="w-100 text-center">
                <h4 className="card-title">Algorithmic Sorting Visualizer</h4>
              </div>
              <hr />
              <p className="card-text">An algorithmic sorting visualizer implementing several highly-used algorithms. This project was done in Python utilizing the Matplotlib modules pyplot and animation.</p>
              <div className="text-center mx-auto">
                <a
                  href="#"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                  data-toggle="modal" data-target="#Modal3"
                >
                  <i className="fas fa-clipboard-check" /> Demo
                </a>

                <a
                  href="https://github.com/scottvcaputo/Algorithmic-Sorting-Visualizer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline-secondary p-2 m-2 col-md-5"
                >
                  <i className="fab fa-github" /> Source
                </a>


              










              </div>
            </div>
          </div>
        </div>

      <div>
        <Modal1 />
        <Modal2 />
        <Modal3 />
      </div>



    
    
    </React.Fragment>




  );
};


export default ProjectCard;